registerComponent("blocks/card-product", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Duas coisas, as mesmas de 2020: as abas Investidores/Institucional (`.tab` →
 * `.tab-content[data-tab]`) e o botão "quero investir", que abre o
 * `modals/modal-investir` com os dados do fundo.
 *
 * ⚠️ O PAR EMISSOR/OUVINTE ESTÁ DIVIDIDO ENTRE DOIS SUB-LOTES, por decisão do
 * programa (armadilha declarada da Fase 5): o `$modalInvestir.trigger('open',
 * [attributes])` de 2020 vira aqui um `CustomEvent('open', { detail })`, e o
 * `modal-investir` só passa a OUVIR isso na Fase 8a. Até lá o botão não abre o
 * modal — é o estado esperado deste branch, não regressão.
 *
 * O `detail` reproduz o que o `.data()` do jQuery entregava, chave a chave e
 * TIPO a tipo: `data-platforms` é JSON no markup e chegava como array;
 * `data-min-aplication="1000"` chegava como número; `""` continua string vazia;
 * atributo ausente é `undefined`. É `Asa.legado.dado()` — o `modal-investir` de
 * 2020 conta com esses tipos, e o segundo emissor do mesmo evento
 * (`pages/product-internal`, 8a) lê os mesmos oito atributos pela mesma função.
 */

const modalInvestir = document.querySelector('[data-component-name="modals/modal-investir"]');
const abas = Array.from(component.querySelectorAll('.tab'));
const conteudos = Array.from(component.querySelectorAll('.tab-content'));

component.querySelectorAll('[data-open-modal]').forEach(function (botao) {
    botao.addEventListener('click', function () {
        const detalhe = {
            aditionalAplication: Asa.legado.dado(botao, 'aditional-aplication'),
            minAplication: Asa.legado.dado(botao, 'min-aplication'),
            minBalance: Asa.legado.dado(botao, 'min-balance'),
            platforms: Asa.legado.dado(botao, 'platforms'),
            productName: Asa.legado.dado(botao, 'product-name'),
            productUrl: Asa.legado.dado(botao, 'product-url'),
            isInstitucional: botao.hasAttribute('data-institucional'),
        };

        if (modalInvestir) {
            modalInvestir.dispatchEvent(new CustomEvent('open', { detail: detalhe }));
        }
    });
});

abas.forEach(function (aba) {
    aba.addEventListener('click', function () {
        const alvo = aba.getAttribute('data-target');

        abas.concat(conteudos).forEach(function (el) {
            el.classList.remove('active');
        });

        aba.classList.add('active');

        component.querySelectorAll(`[data-tab="${alvo}"]`).forEach(function (el) {
            el.classList.add('active');
        });
    });
});

});
